import CoreAPI from '../Core/CoreAPI';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';

class ProcessApi {
  constructor() {
    this.setApi(new CoreAPI(getSessionItem('API_MS_PROCESS_BFF')));
  }

  setApi(api) {
    this.api = api;
  }

  getAPI() {
    if (!this.api.baseURL) this.setApi(new CoreAPI(getSessionItem('API_MS_PROCESS_BFF')));

    return this.api;
  }

  async getPdfInfo(policy) {
    const config = {
      headers: {
        Accept: 'application/pdf'
      },
      responseType: 'arraybuffer'
    };

    const result = await this.getAPI()
      .getInstance()
      .get(`print/internalized/${policy.process.processId}`, config);
    return result;
  }
}

const api = new ProcessApi();
export default api;
